module.exports = __webpack_public_path__ + "static/media/video03.22ffd409.jpg";